import * as XLSX from 'xlsx-js-style'
import moment from 'moment'
import { AppConstants } from '../../../common/APIConstants'
import { mergeChildHeader, mergeDataRows, mergeParentHeader } from './merge'
import { applyStyles } from './excel-styles'
import { getWorkSheetData, segParentHeader, stnParentHeader } from './data'

export const exportGridToExcel = (rowDataSeg, rowDataStn, ccSelected, weekSelected) => {
    try {
        // Create workbook & worksheet
        let workbook = XLSX.utils.book_new();
        // organise data
        let segSheetData = getWorkSheetData([...rowDataSeg], ccSelected, weekSelected, 'Seg')
        // Create worksheet
        let stnSheetData = getWorkSheetData([...rowDataStn], ccSelected, weekSelected, 'Stn')
        // organise data
        let segWorkesheet = XLSX.utils.json_to_sheet(segSheetData, { skipHeader: true })
        // Create worksheet
        let stnWorksheet = XLSX.utils.json_to_sheet(stnSheetData, { skipHeader: true })

        // merge cell for parent headers
        const mergesSegHeader = mergeParentHeader(segParentHeader)
        segWorkesheet["!merges"] = [...mergesSegHeader]
        // apply cell styles
        segWorkesheet = applyStyles(segWorkesheet)
        // merge child headers & slicers
        segWorkesheet = mergeChildHeader(segWorkesheet)
        // merge cell for data
        segWorkesheet = mergeDataRows(segWorkesheet, rowDataSeg)

        // merge cell for parent headers
        const mergesStnHeader = mergeParentHeader(stnParentHeader)
        stnWorksheet["!merges"] = [...mergesStnHeader]
        // apply cell styles
        stnWorksheet = applyStyles(stnWorksheet)
        // merge child headers & slicers
        stnWorksheet = mergeChildHeader(stnWorksheet)
        // merge cell for data
        stnWorksheet = mergeDataRows(stnWorksheet, rowDataStn)

        XLSX.utils.book_append_sheet(workbook, segWorkesheet, 'Segment Alarm')
        XLSX.utils.book_append_sheet(workbook, stnWorksheet, 'Station Alarm')
        const fileName = ccSelected.label.replace(' ', '_') + '_'
            + moment().tz(AppConstants.MT_TIME_FORMATTER).format('_DDMMMYYYY_HHmmss') + '.xlsx';

        // export
        XLSX.writeFile(workbook, fileName, { bookType: 'xlsx', type: 'base64' })
    } catch (err) {
        console.error(err)
        window.toastr.error(AppConstants.TOASTER_ERROR_EXPORT)
    }
}